<div class="container">
    <div class="row marginBottom2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Vorteilskonto von Familie {{currentUser?.person.displayName}}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="row">
                        <div class="col-sm-6 cardText">
                          <br>

                            <h2>
                                {{stats?.sumOfSavings.amount}} {{stats?.sumOfSavings.currency}}
                            </h2>
                            <p><b>Durch genutzte Preisvorteile gesparter Betrag in Euro</b></p>
                        </div>
                        <div class="col-sm-6 cardText">
                            <br>

                            <h2>
                                {{stats?.serviceAttendanceCounter}}
                            </h2>
                            <p><b>Exklusive Vorteile genutzt</b></p>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row marginBottom2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card marginBottom2Rem">
                <mat-card-header>
                    <mat-card-title>Genutzte Vorteile</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <table matSort mat-table [dataSource]="dataSource">
                        <ng-container matColumnDef="number">
                           <th mat-header-cell *matHeaderCellDef>
                               #
                           </th>
                           <td mat-cell *matCellDef="let element; let i = index;" class="mat-column">
                               {{i+1}}
                           </td>
                       </ng-container> 
                       <ng-container matColumnDef="voucherKey">
                           <th mat-header-cell mat-sort-header *matHeaderCellDef>
                               Code
                           </th>
                           <td mat-cell *matCellDef="let element" class="mat-column">
                               {{element?.voucherKey}}
                           </td>
                       </ng-container>
                       <ng-container matColumnDef="event.title">
                           <th mat-header-cell *matHeaderCellDef mat-sort-header>
                               Aktion
                           </th>
                           <td mat-cell *matCellDef="let element" class="mat-column">
                               <span class="customLink"
                                   [routerLink]="['../../../../caseworker/event/edit/'+element?.eventPublicId+'/advanced']">
                                   {{element?.eventTitle}}</span>
                           </td>
                       </ng-container>
                       <ng-container matColumnDef="event.partner.name">
                           <th mat-header-cell *matHeaderCellDef mat-sort-header>
                               Partner
                           </th>
                           <td mat-cell *matCellDef="let element" class="mat-column">
                               <span class="customLink" color="primary"
                                   [routerLink]="['../../../../caseworker/dashboard/edit', element?.partnerPublicId]">
                                   {{element.eventV2?.eventPartner.name}}</span>
                           </td>
                       </ng-container>
                       <!-- <ng-container matColumnDef="attendingAccount.displayName" class="mat-column">
                           <th mat-header-cell *matHeaderCellDef mat-sort-header>
                               Teilnehmer
                           </th>
                           <td mat-cell *matCellDef="let element">
                               <span class="customLink"
                                   [routerLink]="['../../../../caseworker/dashboard/edit', element?.customerPublicId]">
                                   {{element?.customerDisplayName}}</span>
                           </td>
                       </ng-container> -->
                       <ng-container matColumnDef="created" class="mat-column" >
                           <th mat-header-cell *matHeaderCellDef mat-sort-header>
                               Erstellungsdatum
                           </th>
                           <td mat-cell *matCellDef="let element">
                               {{element?.created | date:'dd.MM.yyyy'}}
                           </td>
                       </ng-container>
   
                       <ng-container matColumnDef="menu">
                           <th mat-header-cell *matHeaderCellDef>
                               Menü
                           </th>
                           <td mat-cell *matCellDef="let element">
                               <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu"
                                   color="accent">
                                   <mat-icon>more_vert</mat-icon>
                               </button>
                               <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="getPDF(element.publicId)"
                                       [disabled]="!canPrint(element)">
                                       <span>Gutschein Drucken</span>
                                   </button>

                                   <button mat-menu-item
                                   [routerLink]="['../../../../caseworker/reservation/plus', element.customerPublicId]">
                                   <span>Zum Vorteilskonto</span>
                               </button>
   
                                   <button mat-menu-item
                                       [routerLink]="['../../../../caseworker/dashboard/edit', element.customerPublicId]">
                                       <span>Zum Kunden</span>
                                   </button>
   
                                   <button mat-menu-item
                                       [routerLink]="['../../../../caseworker/event/edit/'+element.eventPublicId+'/advanced']">
                                       <span>Zur Aktion</span>
                                   </button>
                                   <button mat-menu-item
                                       [routerLink]="['../../../../caseworker/businessentity/edit', element.partnerPublicId]">
                                       <span>Zum Partner</span>
                                   </button>
                               </mat-menu>
                           </td>
                       </ng-container>
   
                       <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                       <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index">
                       </tr>
                   </table>
                   <span *ngIf="dataSource?.data.length === 0" class="emptyTableState">Keine passenden
                       Einträge
                       gefunden...</span>
                   <mat-paginator [length]="page.totalElements" class="paginator-centered"
                       [pageSize]="page.size" [pageIndex]="page.number" (page)="loadPage($event)"
                       [pageSizeOptions]="[6, 12, 24, 36]" *ngIf="page">
                   </mat-paginator>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
<!--  *ngIf="finishedLoadingUsers" -->
<div class="container" *ngIf="!finishedLoadingUsers">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>